const getDisplayRating = (rating) => {
    if (rating) {
        return rating.toFixed(1);
    }
};

export default {
    getDisplayRating
};
